import type { FormControlLabelProps } from '@mui/material';
import { FormControl, FormControlLabel, FormHelperText } from '@mui/material';
import { forwardRef } from 'react';
import { Disadvantage32 } from '@packages/themes/icons';
import type { CheckboxProps } from './Checkbox';
import { Checkbox } from './Checkbox';

export interface CheckboxWithLabelProps extends Omit<FormControlLabelProps, 'control'> {
  /** Props passed down to Checkbox component */
  checkboxProps?: CheckboxProps;
  error?: boolean;
  errorMessage?: string;
}

/** Basic checkbox component with label */
export const CheckboxWithLabel = forwardRef<HTMLInputElement, CheckboxWithLabelProps>(
  ({ checkboxProps, error, errorMessage, ...props }, ref) => {
    const { sx: checkboxSx, ...otherCheckboxProps } = { ...checkboxProps };

    return (
      <FormControl>
        <FormControlLabel
          {...props}
          inputRef={ref}
          control={
            <Checkbox
              error={error}
              {...otherCheckboxProps}
              sx={{ ...checkboxSx, marginTop: '-0.25em' }}
              data-testid="checkbox"
            />
          }
          sx={{ alignItems: 'flex-start', paddingTop: '0.25rem' }}
        />
        {error && errorMessage && (
          <FormHelperText
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 0.1,
              color: 'error.main',
              paddingLeft: '2px', // set padding left to match ux design
            }}
          >
            <Disadvantage32 sx={{ width: '1rem', height: '1rem', color: 'error.main' }} />
            {errorMessage}
          </FormHelperText>
        )}
      </FormControl>
    );
  },
);
